import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Por primera vez en mi vida no siento culpa si un día solo hago 5 minutos. Me cambió la relación con mi cuerpo por completo.',
  author: 'María L.',
  role: 'Mamá de 2, 42 años'
}, {
  text: 'Estaba tan rígida que me dolía todo. Los resets de alivio rápido son magia pura. Siento que volví a habitar mi cuerpo.',
  author: 'Sofía T.',
  role: 'Diseñadora, 35 años'
}, {
  text: 'Venía de abandonar 4 gimnasios distintos. Esto es lo único que pude sostener porque no me exige, me acompaña.',
  author: 'Carolina M.',
  role: 'Docente, 48 años'
}];
export function SocialProofFooter() {
  return <footer className="w-full bg-secondary pt-20 pb-10 px-4" data-id="element-171">
      <div className="max-w-6xl mx-auto" data-id="element-172">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-173">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-base p-8 rounded-2xl shadow-sm" data-id="element-174">
              <div className="flex gap-1 text-gold mb-4" data-id="element-175">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-176" />)}
              </div>
              <p className="text-ink/80 italic mb-6" data-id="element-177">"{t.text}"</p>
              <div data-id="element-178">
                <p className="font-medium text-ink" data-id="element-179">{t.author}</p>
                <p className="text-sm text-ink/60" data-id="element-180">{t.role}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="border-t border-ink/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-ink/50" data-id="element-181">
          <p data-id="element-182">
            © {new Date().getFullYear()} MOVÉ SUAVE™. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-183">
            <a href="#" className="hover:text-ink transition-colors" data-id="element-184">
              Términos
            </a>
            <a href="#" className="hover:text-ink transition-colors" data-id="element-185">
              Privacidad
            </a>
            <a href="#" className="hover:text-ink transition-colors" data-id="element-186">
              Soporte
            </a>
          </div>
        </div>
      </div>
    </footer>;
}